// ════════════════════════════════════════════════════════════════════════════
//  Udisys Gestor Web  —  src/features/financeiro/services/relatoriosService.ts
// ════════════════════════════════════════════════════════════════════════════

import { apiClient } from '@/lib/apiClient';
import type {
  AgingRelatorio, InadimplenciaRelatorio, FluxoCaixa,
  FluxoCaixaCenarios, FluxoCaixaCenariosParams,
} from '../types';

const BASE = '/api/financeiro/relatorios';

export const relatoriosService = {
  async agingPagar(dataBase?: string): Promise<AgingRelatorio> {
    const { data } = await apiClient.get<AgingRelatorio>(`${BASE}/aging-pagar`, {
      params: dataBase ? { dataBase } : undefined,
    });
    return data;
  },

  async agingReceber(dataBase?: string): Promise<AgingRelatorio> {
    const { data } = await apiClient.get<AgingRelatorio>(`${BASE}/aging-receber`, {
      params: dataBase ? { dataBase } : undefined,
    });
    return data;
  },

  async inadimplencia(
    tipo: 'receber' | 'pagar' = 'receber',
    diasMinimos = 1,
    dataBase?: string,
  ): Promise<InadimplenciaRelatorio> {
    const { data } = await apiClient.get<InadimplenciaRelatorio>(`${BASE}/inadimplencia`, {
      params: { tipo, diasMinimos, ...(dataBase ? { dataBase } : {}) },
    });
    return data;
  },

  async fluxoCaixa(
    dtInicio?: string,
    dtFim?: string,
    agrupamento: 'dia' | 'semana' | 'mes' = 'dia',
  ): Promise<FluxoCaixa> {
    const { data } = await apiClient.get<FluxoCaixa>(`${BASE}/fluxo-caixa`, {
      params: { dtInicio, dtFim, agrupamento },
    });
    return data;
  },

  async fluxoCaixaCenarios(params: FluxoCaixaCenariosParams): Promise<FluxoCaixaCenarios> {
    const { data } = await apiClient.get<FluxoCaixaCenarios>(`${BASE}/fluxo-caixa-cenarios`, {
      params,
    });
    return data;
  },
};
